export default __webpack_public_path__ + "static/measurement-chart-4e37dc8653c637758a539bed1826b0fe.png";